<template>
  <div class="alignment">
    <template>
      <v-layout row wrap>
        <v-flex xs6 class="text-xs-left"
          ><h3 class="styleHeader">
            {{ $t("pages.User.Index.Utente") }}
          </h3></v-flex
        >
        <v-flex>
          <v-btn
            class="right white--text styleHeader styleAlignamentAddButton"
            :to="$i18nRoute({ name: 'UserCreate' })"
            color="#279947"
          >
            <v-icon left>add</v-icon>
            {{ $t("pages.User.Index.Aggiungi") }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="[
          {
            text: this.currentLanguage.t('pages.User.Index.CodGestionale'),
            align: 'left',
            sortable: true,
            value: 'CodAltKN'
          },
          {
            text: this.currentLanguage.t('pages.User.Index.Azienda'),
            value: 'Company'
          },
          {
            text: this.currentLanguage.t('pages.User.Index.Email'),
            value: 'Email'
          },
          {
            text: this.currentLanguage.t('pages.User.Index.Nome'),
            value: 'Nome'
          },
          {
            text: this.currentLanguage.t('pages.User.Index.Cognome'),
            value: 'Cognome'
          },
          { text: '' }
        ]"
        :items="users"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>{{ props.item.CodAltKN }}</td>
          <td>{{ props.item.Company }}</td>
          <td>{{ props.item.Email }}</td>
          <td>{{ props.item.Nome }}</td>
          <td>{{ props.item.Cognome }}</td>
          <td>
            <v-btn flat icon class="right" @click="editItem(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import usersApi from "../../apiSmartLogistics/usersApi.js";
import router from "@/router/index.js";

import { Trans } from "@/plugins/Translation";
export default {
  data() {
    return {
      users: []
    };
  },
  methods: {
    editItem(item) {
      router.push({ name: "UserCreate", params: { Id: item.Id } });
    }
  },
  computed: {
    currentLanguage() {
      return Trans.i18n;
    }
  },
  created() {
    usersApi.GetUsers().then(response => {
      this.users = response.data;
    });
  }
};
</script>
